<template>
    <div class="Alert">
    <div class="Alert__background" @click="onClick()"/>
        <div class="Alert__container roboto" :class="{ 'cursor': alert=='clipboard' }"> 
            <template v-if="alert=='clipboard'">
                <div class="Alert__icon">
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20.14 14.2">
                        <g>
                            <path fill="#fff" id="rect9346" d="M2.7,0c-.6,0-1.16,.19-1.61,.52L10.04,6.48,19.02,.5c-.44-.31-.99-.5-1.58-.5H2.7Zm7.33,8.16l-2.21-1.48L1.19,12.52l-.69,.57c.49,.67,1.29,1.11,2.2,1.11h14.75c.9,0,1.7-.43,2.19-1.09l-7.36-6.44-2.25,1.48ZM19.92,1.58l-6.42,4.28,6.64,5.81s0-.06,0-.1V2.63c0-.37-.08-.73-.22-1.05ZM.21,1.61c-.14,.31-.21,.66-.21,1.02V11.57s0,.03,0,.04L6.59,5.86,.21,1.61Z"/>
                        </g>
                    </svg>
                </div>
                <div class="Alert__email">{{ address }}</div>
                <div class="Alert__copied" v-html="trans('Global.copied')"/>
                <div class="Alert__clipboard" v-html="trans('Global.clipboard')"/>
            </template>
            <template v-if="alert=='store'">
                <div class="Alert__email">RWG</div>
                <div class="Alert__sentence-1" v-html="trans('Global.now')"/>       
                <div class="Alert__icon store">
                    <div class="Alert__icon-svg" @click="onStore('google')"><Google/></div>
                    <div class="Alert__icon-svg" @click="onStore('apple')"><Apple/></div>
                </div>
            </template>

        </div>
    </div>
</template>

<script>

import gsap from "gsap"
import Settings from "@/config/Settings"
import Apple from "@/components/assets/svg/Apple"
import Google from "@/components/assets/svg/Google"

export default {

    name: 'Alert',
    components: { Apple, Google },
    data: ()=>({
       address: 'info'
    }),
    computed:{
        alert() { return this.$store.getters['commons/alert'] },
    },
    created() {
        this.address = Settings.email
    },
    mounted() { 
        this.$nextTick(()=>{

            const arr = this.alert == 'clipboard' 
                    ? ['.Alert__container', '.Alert__icon', '.Alert__email', '.Alert__copied', '.Alert__clipboard']
                    : ['.Alert__container', '.Alert__email', '.Alert__sentence-1', '.Alert__icon' ] 

            gsap.timeline({ delay: .25 })
                .from(this.$el, { opacity: 0, duration : .25, ease: 'none' })
                .from(arr, { duration: .35, y: 50, ease: 'cubic.out', stagger: .15, opacity: 0 })
        })
    },
    methods: {
        onClick() {
            gsap.to(this.$el, { opacity: 0, duration : .25, ease: 'none', onComplete: ()=>{
                this.$store.commit('commons/ADD_ALERT', null)
            }}) 
        },
        onStore(ref) {
            window.open(Settings.link[ref], '_blank')
        },
    }
}
</script>

<style lang='stylus'>

@import '~@/commons/stylus/Media-queries'
@import '~@/config/Settings'

.Alert
    width 100%
    position fixed
    top 0
    left 0  
    width 100%
    height 100%
    z-index 2000
    background-color rgba(dark, .75)
    display flex
    align-items center
    justify-content center
    color white

    &__background 
        width 100%
        height 100%
        position absolute
        cursor pointer
   
    &__container
        position relative 
        display flex
        flex-direction column
        justify-content center
        align-items center
        background-color rgba(dark, 1)

        padding var(--hd)
        border-radius var(--mw)

        &.cursor
            pointer-events none

    &__icon
        width calc(var(--hd)*.75)
        padding-bottom 8px

        &.store
            display flex
            width 100%
            cursor pointer

        &-svg
            width 54px
            margin 8px

    &__email 
        font-weight bold
        padding-bottom 2px

    &__field
        position absolute
        opacity .2
        width 200%
        top 50%

    &__sentence-1
        padding-bottom 16px

    
</style>


